import { useEffect } from 'react'
import { MODAL_NAME } from 'Constants/ModalName'
import { MODAL_SIZE } from 'Constants/Global'
import { useAppDispatch } from 'Src/hooks'
import { Callback } from 'Src/types/utilTypes'
import {
	ActiveLead,
	AgreementModal,
	ChangeLeadModal,
	RequestType,
	STATUS_WITH_ALLOWED_SEND,
	GovLeadModal,
	BG_MODAL_SIZES,
	Lead,
	BgLimitRequestFull,
} from 'Pages/ibro'
import { modalsSlice } from 'Modules'
import { FieldNames } from 'Constants/FieldNames'

export const useChangeLead = (
	item: Lead | BgLimitRequestFull,
	itemSelector: Callback,
	requestType?: RequestType,
	onLeadChange?: Callback<ActiveLead | undefined>,
	isSigner?: boolean
) => {
	const { showModal } = useAppDispatch({
		showModal: modalsSlice.actions.showModal,
	})
	const { active_leads, fio, status } = item
	let activeLead
	if (item[FieldNames.FIO]) {
		activeLead = active_leads?.find(
			(lead) => lead.fio?.toLowerCase() === item[FieldNames.FIO].toLowerCase()
		)
	} else {
		activeLead = active_leads?.find((lead) => lead.fio?.toLowerCase() === fio?.toLowerCase())
	}

	const disabledAll = status?.status_slug && !STATUS_WITH_ALLOWED_SEND.includes(status?.status_slug)
	const changeOptions = { is_director: false }
	const createOptions = { attorney: isSigner || false }

	const openModalAgreement = () => {
		showModal({
			key: MODAL_NAME.AGREEMENT_BG,
			Component: AgreementModal,
			width: BG_MODAL_SIZES.M,
			componentProps: {
				item,
				itemSelector,
				requestType,
				createOptions,
				changeOptions,
			},
		})
	}
	const changeLead = () =>
		activeLead
			? showModal({
					key: MODAL_NAME.CHANGE_LEAD_BG,
					Component: ChangeLeadModal,
					componentProps: {
						openModalAgreement,
						itemSelector,
						requestType,
						changeOptions,
					},
					width: MODAL_SIZE.S,
			  })
			: openModalAgreement()

	const changeSigantoryLead = () =>
		active_leads.length
			? showModal({
					key: MODAL_NAME.CHANGE_LEAD_BG,
					Component: GovLeadModal,
					componentProps: {
						openModalAgreement,
						itemSelector,
						requestType,
						changeOptions,
						isSigner,
					},
					width: BG_MODAL_SIZES.S,
			  })
			: openModalAgreement()

	useEffect(() => {
		onLeadChange?.(activeLead)
	}, [activeLead?.fio])

	return { openModalAgreement, disabledAll, changeLead, activeLead, changeSigantoryLead }
}
